import React from 'react';
import { connect } from 'react-redux';
import { IState } from '../state/State';
import { ILogInType } from '../actions/LogInActions';

export interface ISignedInLoginBodyProps {
  logInState: ILogInType;
}

const SignedInLoginBody: React.FC<ISignedInLoginBodyProps> = React.memo((props: ISignedInLoginBodyProps) => {
    
    return (
      <div className="SignedInLoginBody">
        <label>Successfully signed in!</label>
      </div>
    );
});

const mapStateToProps = (state: IState) => ({
  logInState: state.logIn.result
});

export default connect(mapStateToProps)(SignedInLoginBody);
